const REPROCESS_MODAL = "REPROCESS-MODAL";
const SELECTOR_MODAL = "SELECTOR-MODAL";
const NO_ATTACHMENTS_MODAL = "NO-ATTACHMENTS-MODAL";
const PROCESS_STATUS_MODAL = "PROCESS-STATUS-MODAL";
const PROCESS_RESULT_MODAL = "PROCESS-RESULT-MODAL";
const TASK_STATUS_COMPLETE = "Complete";
const TASK_STATUS_FAILED = "Failed";
const TASK_STATUS_CANCELLED = "Cancelled";
const TASK_STATUS_PENDING = "Pending";
const TASK_STATUS_STARTING = "Starting";
const PLOT_WORKFLOW = "ExtractPlotStep";
const WORKFLOWS = [PLOT_WORKFLOW];

export const RECOMMENDATION_API_CONSTANTS = {
  REPROCESS_MODAL,
  SELECTOR_MODAL,
  NO_ATTACHMENTS_MODAL,
  PROCESS_STATUS_MODAL,
  PROCESS_RESULT_MODAL,
  TASK_STATUS_COMPLETE,
  TASK_STATUS_FAILED,
  TASK_STATUS_CANCELLED,
  TASK_STATUS_PENDING,
  TASK_STATUS_STARTING,
  PLOT_WORKFLOW,
  WORKFLOWS,
};
